// extracted by mini-css-extract-plugin
export default {"grid":"xibkZ","list":"G4N4r","listItem":"SuUpL","grid-looks-desktop":"Kzewv"};